// extracted by css-extract-rspack-plugin
export default {"copyButtonCopied":"copyButtonCopied_Mzdr","copyButtonIcons":"copyButtonIcons_MVhB","copyButtonIcon":"copyButtonIcon_yxgH","copyButtonSuccessIcon":"copyButtonSuccessIcon_QJLJ"};